import * as AlertBarState from '../../components/alert-bar/AlertBar.state';
import * as ModalState from '../../components/modal/Modal.state';
import { CancelOrderFormModal } from './CartModals';
import * as Nested from '../../utils/Nested';
import { REOPEN_SUCCESS } from '../order-details/OrderDetails.state';
import { PAYMENT_SUCCESS } from '../checkout/Checkout.state';
import { formatCurrency } from '../../utils/helpers';
import { TRANSACTION_STATUS } from '../../utils/constants';

// Default State
const initialState = {
  fetching: false,
  error: false,
  order: {},
};

// Action Creators and Action Types

const ADD_TO_CART_SUCCESS = 'ADD_TO_CART_SUCCESS';
export const GET_ORDER_REQUEST = 'GET_ORDER_REQUEST';
export const getOrderRequest = () => ({
  type: GET_ORDER_REQUEST,
});

export const GET_ORDER_SUCCESS = 'GET_ORDER_SUCCESS';
export const getOrderSuccess = (data) => ({
  type: GET_ORDER_SUCCESS,
  payload: data,
});

export const GET_ORDER_ERROR = 'GET_ORDER_ERROR';
/**
 * Records a failed current-order request.
 *
 * @param {string} data - The request failure message.
 * @returns {{type: string, payload: string}} The Redux error action.
 */
export const getOrderError = (data) => ({
  type: GET_ORDER_ERROR,
  payload: data,
});

export const CLEAR_CART = 'CLEAR_CART';
export const clearCart = () => ({
  type: CLEAR_CART,
});

export const GET_UPDATED_CART_REQUEST = 'GET_UPDATED_CART_REQUEST';
export const getUpdatedCartRequest = (data) => ({
  type: GET_UPDATED_CART_REQUEST,
  payload: data,
});

export const GET_UPDATED_CART_SUCCESS = 'GET_UPDATED_CART_SUCCESS';
export const getUpdatedCartSuccess = (data) => ({
  type: GET_UPDATED_CART_SUCCESS,
  payload: data,
});

export const GET_UPDATED_CART_ERROR = 'GET_UPDATED_CART_ERROR';
export const getUpdatedCartError = (data) => ({
  type: GET_ORDER_DETAILS_ERROR,
  payload: data,
});

export const HOLD_ORDER_REQUEST = 'HOLD_ORDER_REQUEST';
export const holdOrderRequest = (data) => ({
  type: HOLD_ORDER_REQUEST,
  payload: data,
});

export const HOLD_ORDER_SUCCESS = 'HOLD_ORDER_SUCCESS';
export const holdOrderSuccess = (data) => ({
  type: HOLD_ORDER_SUCCESS,
  payload: data,
});

export const SUBMIT_CANCEL_ORDER_REQUEST = 'SUBMIT_CANCEL_ORDER_REQUEST';
export const submitCancelOrderRequest = (data) => ({
  type: SUBMIT_CANCEL_ORDER_REQUEST,
  payload: data,
});

export const CANCEL_ORDER_SUCCESS = 'CANCEL_ORDER_SUCCESS';
export const cancelOrderSuccess = (data) => ({
  type: CANCEL_ORDER_SUCCESS,
  payload: data,
});

export const CANCEL_ORDER_ERROR = 'CANCEL_ORDER_ERROR';
export const cancelOrderError = (data) => ({
  type: CANCEL_ORDER_ERROR,
  payload: data,
});

export const REMOVE_ORDER_ITEM_REQUEST = 'REMOVE_ORDER_ITEM_REQUEST';
export const removeOrderItemRequest = (data) => ({
  type: REMOVE_ORDER_ITEM_REQUEST,
  payload: data,
});

export const REMOVE_ORDER_ITEM_SUCCESS = 'REMOVE_ORDER_ITEM_SUCCESS';
export const removeOrderItemSuccess = (data) => ({
  type: REMOVE_ORDER_ITEM_SUCCESS,
  payload: data,
});

export const REMOVE_ORDER_ITEM_ERROR = 'REMOVE_ORDER_ITEM_ERROR';
export const removeOrderItemError = (data) => ({
  type: REMOVE_ORDER_ITEM_ERROR,
  payload: data,
});

export const INITIATE_VOID_TRANSACTION = 'INITIATE_VOID_TRANSACTION';
export const initiateVoidTransactionById = (data) => ({
  type: INITIATE_VOID_TRANSACTION,
  payload: data,
});

export const VOID_TRANSACTION_SUCCESS = 'VOID_TRANSACTION_SUCCESS';
export const voidTransactionSuccess = (data) => ({
  type: VOID_TRANSACTION_SUCCESS,
  payload: data,
});

export const VOID_TRANSACTION_ERROR = 'VOID_TRANSACTION_ERROR';
export const voidTransactionError = (data) => ({
  type: VOID_TRANSACTION_ERROR,
  payload: data,
});

// Intentionally distinct from order-details' STOP_VOID_ORDER_POLLING: each void
// polling loop's takeUntil listens only for its own stop type. Unifying the two
// (a tempting "DRY" refactor) would let one stop signal cross-terminate a
// concurrent void loop in the other epic.
export const STOP_VOID_TRANSACTION_POLLING = 'STOP_VOID_TRANSACTION_POLLING';
export const stopVoidTransactionPolling = () => ({
  type: STOP_VOID_TRANSACTION_POLLING,
});

// Alert Bar Nested Actions
export const ALERT_BAR_ACTION = 'cart/ALERT_BAR_ACTION';
export const cartAlertBarAction = Nested.nestedAction(ALERT_BAR_ACTION);

// Modal Nested Actions
export const MODAL_ACTION = 'cart/MODAL_ACTION';
export const cartModalAction = Nested.nestedAction(MODAL_ACTION);

// Form Actions
export const CANCEL_ORDER_FORM_ACTION = 'cart/CANCEL_ORDER_FORM_ACTION';
export const cancelOrderFormAction = Nested.nestedAction(
  CANCEL_ORDER_FORM_ACTION,
);

// Raw Reducer
export const _reducer = (state = initialState, { type, payload } = action) => {
  switch (type) {
    case ADD_TO_CART_SUCCESS:
      return {
        ...state,
        order: {
          ...state.order,
          ...payload,
        },
        fetching: false,
      };
    case GET_ORDER_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case GET_ORDER_SUCCESS:
      return {
        ...state,
        order: {
          ...state.order,
          ...payload,
        },
        fetching: false,
      };
    case GET_ORDER_ERROR:
      return {
        ...state,
        fetching: false,
        error: true,
      };
    case HOLD_ORDER_SUCCESS:
    case CANCEL_ORDER_SUCCESS:
      return {
        ...state,
        order: {},
        fetching: false,
      };
    case CANCEL_ORDER_ERROR:
      return {
        ...state,
        fetching: false,
        error: true,
      };
    case SUBMIT_CANCEL_ORDER_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case REMOVE_ORDER_ITEM_SUCCESS:
      return {
        ...state,
        order: payload,
        fetching: false,
      };
    case REMOVE_ORDER_ITEM_ERROR:
      return {
        ...state,
        fetching: false,
      };
    case CLEAR_CART:
      return { ...state, order: initialState.order };
    case GET_UPDATED_CART_SUCCESS:
      return {
        ...state,
        fetching: false,
        order: {
          ...state.order,
          status: payload?.data?.order?.status,
          remaining_balance: payload?.data?.order?.remaining_balance,
        },
      };
    case REOPEN_SUCCESS:
      return {
        ...state,
        order: payload.data,
      };
    case PAYMENT_SUCCESS:
      return {
        ...state,
        order: {
          ...state.order,
          transaction_details: [
            ...(state.order?.transaction_details?.length
              ? state.order.transaction_details
              : []),
            payload.data,
          ],
        },
      };
    case INITIATE_VOID_TRANSACTION:
      return {
        ...state,
        fetching: true,
      };
    case VOID_TRANSACTION_SUCCESS:
      return {
        ...state,
        order: {
          ...state.order,
          remaining_balance: formatCurrency(
            Number(state.order.remaining_balance) +
              Number(
                state.order?.transaction_details?.find(
                  (t) => t.id === payload.id,
                )?.amount_processed || 0,
              ),
          ),
          transaction_details: state.order?.transaction_details?.map((t) => ({
            ...t,
            status:
              t.id === payload.id ? TRANSACTION_STATUS.CANCELLED : t.status,
          })),
        },
        fetching: false,
        error: false,
      };
    case VOID_TRANSACTION_ERROR:
      return {
        ...state,
        fetching: false,
        error: true,
      };
    default:
      return state;
  }
};

// Selectors
// Includes cancel_pending to prevent auto-cancellation during an in-flight DPS void
export const selectHasSuccessfulPayments = (state) =>
  state.cart?.order?.transaction_details?.some(
    (t) =>
      t.status === TRANSACTION_STATUS.SUCCESSFUL ||
      t.status === TRANSACTION_STATUS.CANCEL_PENDING,
  ) ?? false;

const invalidItemAdditionAlert = {
  heading: 'Cart Page Error',
  text: 'New items cannot be added because the order is partially paid.',
  variant: 'error',
};

// Raw Redux Maps
export const _mapStateToProps = (state) => ({
  ...state.cart,
});
export const _mapDispatchToProps = (dispatch) => ({
  getOrder: () => dispatch(getOrderRequest()),
  removeOrderItemRequest: (item_id) =>
    dispatch(removeOrderItemRequest(item_id)),
  displayAddItemsAlert: () =>
    dispatch(
      cartAlertBarAction(AlertBarState.replaceAlerts(invalidItemAdditionAlert)),
    ),
});

// Nested Redux Maps
const {
  reducer: nestedReducer,
  mapStateToProps,
  mapDispatchToProps,
  actions,
} = Nested.nestStates(
  {
    reducer: _reducer,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps,
  },
  {
    forms: {
      cancelOrderForm: {
        ...CancelOrderFormModal,
        actionType: CANCEL_ORDER_FORM_ACTION,
      },
    },
    alertBars: {
      cartAlertBars: {
        ...AlertBarState,
        actionType: ALERT_BAR_ACTION,
      },
    },
    modals: {
      cartModal: {
        ...ModalState,
        actionType: MODAL_ACTION,
      },
    },
  },
  'cart',
);

// Nested Reducer
const reducer = (state, action) => nestedReducer(state, action);
export { reducer, mapStateToProps, mapDispatchToProps, actions };
